import React from 'react';
import cx from 'classnames';
import Styles from './index.module.scss';

interface IUploadCommonModal {
  children: React.ReactElement;
  title: string;
  onCancel: ()=>void;
  contentClassName?: string;
}
const CommonModal = ({
  children,
  title,
  contentClassName,
  onCancel,
}:IUploadCommonModal) => {
  return (
    <div className={Styles.root}>
      <div className={Styles.mask}></div>
      <div className={Styles.contentWrapper}>
        <div className={cx(Styles.content, contentClassName)}>
          <div className={Styles.header}>
            <p>{title}</p>
            <i className={Styles.closeIcon} onClick={onCancel} />
          </div>
          { children }
        </div>
      </div>
    </div>
  );
}

export default CommonModal;